import React, { useState } from "react";
import styles from "./OfferHistory.module.scss";
import { genOfferTypeText, timestampToTime } from "../../../utils/GeneralUtils";
import SonicLink from "../../../common/routing/SonicLink";

type Props = {
  isRecipient: boolean;
  timestamp: number;
  contentId?: string;
  contentName: string;
  senderId: string;
  senderName: string;
  offerType: string;
  question: string;
  otherReasons?: string;
};

const OfferHistoryItem: React.FC<Props> = ({
  isRecipient,
  timestamp,
  contentId,
  contentName,
  senderId,
  senderName,
  offerType,
  question,
  otherReasons,
}) => {
  const [isShown, setIsShown] = useState<boolean>(false);

  return (
    <>
      <div className={styles["offer-history_item"]}>
        <div className={styles["offer-history_item_head-wrap"]}>
          <div className={styles["offer-history_item_head"]}>
            <span>{timestampToTime(timestamp, false, false)}</span>
            <span
              className={`${styles["offer-history_item_head_type"]} ${
                styles[`${isRecipient ? "reception" : "send"}`]
              }`}
            >
              {isRecipient ? "受信" : "送信"}
            </span>
            <span className={styles["offer-history_item_head_title"]}>
              {isRecipient
                ? `「${senderName}」さんからオファーがきました。`
                : `「${contentName}」さんにオファーしました。`}
            </span>
          </div>
          <button
            type="button"
            onClick={() => setIsShown(!isShown)}
            className={`${styles["offer-history_item_btn"]} ${
              styles[`${isShown ? "opened" : "closed"}`]
            }`}
          >
            <span>{isShown ? "閉じる" : "詳細"}</span>
          </button>
        </div>

        {/* 開いた後に表示するオファー詳細テーブル */}
        <div
          className={`${styles["offer-history_item_detail"]} ${
            styles[`${isShown ? "opened" : "closed"}`]
          }`}
        >
          <span>依頼者名</span>
          <span>
            <SonicLink to={`/user/${senderId}`} newTab={true}>
              {isRecipient ? senderName : `${senderName}（あなた）`}
            </SonicLink>
          </span>
          <span>対象プロフィール名</span>
          <span>
            {contentId ? (
              <SonicLink to={`/person/${contentId}`} newTab={true}>
                {contentName}
              </SonicLink>
            ) : (
              contentName
            )}
          </span>
          <span>オファー種別</span>
          <span>{genOfferTypeText(offerType)}</span>
          {otherReasons ? (
            <>
              <span>オファー内容</span>
              <span>{otherReasons}</span>
            </>
          ) : null}
          <span>オファー詳細や質問</span>
          <span>
            {question ? question : "オファー詳細や質問はございません"}
          </span>
        </div>
      </div>
    </>
  );
};

export default OfferHistoryItem;
